<template>
  <ReadField label="Imported From" :val="item?.importedFromPath" :span="2" />
  <ReadField label="Document Date" :val="sysDate.shortDateString(item?.documentDate)" />
  <ReadField label="Storage Container" :val="item?.storageContainer" />
  <ReadField label="Public?" :val="item?.forPublic" />
  <ReadField label="Confidential Comment" :val="item?.confidentialComment" multiline />
  <ReadField label="Sent From Individual" :val="item?.sentFromIndividual" />
  <ReadField label="Sent From Organization" :val="item?.sentFromOrganization" />
  <ReadField label="Sent To Individual" :val="item?.sentToIndividual" />
  <ReadField label="Sent To Organization" :val="item?.sentToOrganization" />
  <ReadRow :columns="3">
    <ReadField label="Corr Log No." :val="item?.corrLogNumber" />
    <ReadField label="Governor No." :val="item?.governorNumber" />
    <ReadField label="Director No." :val="item?.directorNumber" />
  </ReadRow>
  <ReadField label="Notes" :val="item?.notes" multiline :span="2" />
</template>

<script lang="ts">
export default defineComponent({
  name: "DocumentListPageExtension",
});
</script>

<script setup lang="ts" generic="T extends Doc">
import type { Doc } from "@modernary/mui/components/document";
import { ReadField, ReadRow } from "@modernary/mui/components/read";
import { sysDate } from "@modernary/mui/utils/filters";
import { defineComponent } from "vue";

defineProps<{ item?: T }>();
</script>
